"use client"

import { Translate } from "@/components/translate"
import { useConfigParams } from "@/hooks/use-config-params"
import { trackAnalyticsEvent } from "@/lib/analytics"
import Link from "next/link"

export function RegisterButton() {
  const signupUrl = useSignupUrl()

  const handleClick = () => {
    trackAnalyticsEvent({
      event: "link_click",
      event_name: "nav_click",
      conversion_pagename: "login",
      position: "login",
      cta_label: "registrati",
    })
  }

  return (
    <Link
      data-qa="register-button"
      className="bg-btn-outlined-bg border-px text-paragraph-m text-btn-outlined-text rounded-btn mb-8 inline-flex h-9 items-center justify-center border-(--btn-secondary-outlined-border) px-3 py-1.5 font-bold tracking-wide disabled:pointer-events-none disabled:opacity-40"
      onClick={handleClick}
      href={signupUrl}
    >
      <Translate i18nKey="LoginPage.signupCta" />
    </Link>
  )
}

function useSignupUrl() {
  const { channel, authType, endCallbackUrl, communityShare, community } =
    useConfigParams()

  const url = new URL(`${window.APP_REDIRECT_REG}`)
  url.searchParams.set("auth-type", authType)
  url.searchParams.set("siteid", channel.toString())
  if (community) {
    url.searchParams.set("community", "true")
  }
  if (communityShare) {
    url.searchParams.set("communityShare", communityShare)
  }
  if (endCallbackUrl) {
    url.searchParams.set("endcallbackurl", endCallbackUrl)
  }
  return url
}
